module.exports = __webpack_public_path__ + "img/96.a6d437ab.svg";